exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-text[data-v-38fa1a4e] {\n    max-height: 500px;\n    overflow-y: auto;\n}\n.nps-metric[data-v-38fa1a4e]{\n    font-weight: 700 !important;\n    font-size: 22px !important;\n}\n", ""]);

// exports
